export const CAP_CATEGORY_ORDER = [
  "Céréales d'hiver",
  'Céréales de printemps',
  "Oléagineux d'hiver",
  'Oléagineux de printemps',
  "Fixatrices d'Azote",
  'Prairies Permanentes',
  'Prairies Temporaires Et Jachère',
  'Plantes sarclées',
  'Autre culture TA',
  'Aucune',
];

/**
 * Trier des cultures par capCategory puis par nom
 */
export const sortByCAPCategory = (a, b) => {
  const catA = CAP_CATEGORY_ORDER.indexOf(a.capCategory ?? 'Aucune');
  const catB = CAP_CATEGORY_ORDER.indexOf(b.capCategory ?? 'Aucune');
  const orderA = catA === -1 ? CAP_CATEGORY_ORDER.length : catA;
  const orderB = catB === -1 ? CAP_CATEGORY_ORDER.length : catB;
  if (orderA !== orderB) return orderA - orderB;
  return (a.label ?? a.name ?? '').localeCompare(b.label ?? b.name ?? '', 'fr');
};

export const sortCultures = (cultures) => {
  if (!cultures?.length) return cultures ?? [];
  return [...cultures].sort(sortByCAPCategory);
};
